/* eslint-disable eol-last */
// export const API_URL = 'https://je.inspia.net/backend/api'
export const API_URL = 'https://api.newturquoisejewelry.com/api'
